module.exports = __webpack_public_path__ + "assets/images/slope-size/tablet.svg?v=1d18152a";